import * as React from 'react';
export const fidorSvg = React.forwardRef(function fidorSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#7DAC04',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.244 13.036A10.182 10.182 0 0 1 16 5.818c.064 0 .127-.002.188-.003a2.91 2.91 0 0 1 .35.003A13.57 13.57 0 0 0 8.83 18.08a13.498 13.498 0 0 0 1.63 6.458l-.132-.073a10.182 10.182 0 0 1-4.083-11.429ZM16 26.182c-1.02.001-2.036-.15-3.01-.451l-.06-.03a8.205 8.205 0 0 1-1.803-3.127 8.203 8.203 0 0 1 7.826-10.589A7.927 7.927 0 0 1 26.182 16C26.007 21.469 21.527 26.182 16 26.182Zm9.876-12.699a9.6 9.6 0 0 0-6.923-2.938 9.629 9.629 0 0 0-8.422 4.975c.96-4.451 4.364-8 8.727-9.164a10.196 10.196 0 0 1 6.618 7.127Z',
      fill: '#fff',
    }),
  );
});
fidorSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var fidor = {
  category: 'brand',
  colorable: false,
  name: 'fidor',
  svg: fidorSvg,
};
